const MAKE_SHELL_ROOT = '/make-shell';

const route = (segment: string, title: string) => ({
  segment,
  title,
  path: segment ? `${MAKE_SHELL_ROOT}/${segment}` : MAKE_SHELL_ROOT,
  relativePath: segment ? `/${segment}` : '/',
});

export const MAKE_SHELL_ROUTES = {
  root: route('', 'Version matrix'),
  fleets: route('fleets', 'Fleet anchors'),
  buckets: route('buckets', 'Buckets'),
  deployments: route('deployments', 'Deployments'),
  simulate: route('simulate', 'Simulate'),
  readiness: route('readiness', 'Integration readiness'),
  devbox: route('devbox', 'Devbox'),
  detail: route('mfe/:mfeName', 'MFE detail'),
  legacyNegotiation: route('negotiation', 'Negotiation'),
} as const;

export const getMakeShellMfePath = (
  rootPath: string,
  mfeName: string,
  deploymentId: string,
) =>
  `${rootPath}/${MAKE_SHELL_ROUTES.detail.segment.replace(
    ':mfeName',
    encodeURIComponent(mfeName),
  )}?deployment=${encodeURIComponent(deploymentId)}`;

export const getMakeShellBucketsPath = (
  rootPath: string,
  deploymentId: string,
) =>
  `${rootPath}/${
    MAKE_SHELL_ROUTES.buckets.segment
  }?deployment=${encodeURIComponent(deploymentId)}`;

/**
 * The Fleet anchors view of one fleet. The fleet is a query parameter, like the
 * deployment elsewhere, so the view's own fleet picker can rewrite it.
 */
export const getMakeShellFleetPath = (rootPath: string, fleetId: string) =>
  `${rootPath}/${MAKE_SHELL_ROUTES.fleets.segment}?fleet=${encodeURIComponent(
    fleetId,
  )}`;

const MAKE_SHELL_SUBMENU_ROUTES = [
  MAKE_SHELL_ROUTES.fleets,
  MAKE_SHELL_ROUTES.buckets,
  MAKE_SHELL_ROUTES.deployments,
  MAKE_SHELL_ROUTES.simulate,
  MAKE_SHELL_ROUTES.readiness,
  MAKE_SHELL_ROUTES.devbox,
];

export const MAKE_SHELL_SUBMENU_ITEMS = MAKE_SHELL_SUBMENU_ROUTES.map(
  ({ path: to, title }) => ({ title, to }),
);
